/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Marketing_BodyInputs */

const en_wb_marketing_body = /** @type {(inputs: Wb_Marketing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website visits increased from 3,200 to 3,680. Form submissions fell from 48 to 41 over the same period.`)
};

const lv_wb_marketing_body = /** @type {(inputs: Wb_Marketing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vietnes apmeklējumu skaits pieauga no 3200 līdz 3680. Aizpildīto formu skaits tajā pašā periodā samazinājās no 48 līdz 41.`)
};

/**
* | output |
* | --- |
* | "Website visits increased from 3,200 to 3,680. Form submissions fell from 48 to 41 over the same period." |
*
* @param {Wb_Marketing_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_marketing_body = /** @type {((inputs?: Wb_Marketing_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Marketing_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_marketing_body(inputs)
	return en_wb_marketing_body(inputs)
});